import React from 'react'
import { Helmet } from 'react-helmet'
import type { HowGoustoFoodBoxesWorkTypes } from '../../types'
import { SEO } from './config'
import {
  BannerImageSection,
  ExploreGoustoSection,
  ExploreMenuSection,
  FAQSection,
  HeroSection,
  HowDoesGoustoMenuWork,
  HowMuchDoesGoustoCost,
  MealPlanningBannerSection,
  MenuCarousel,
  TestimonialSection,
  WhyChooseGoustoSection,
} from './sections'

export function MealPlanningPage({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <>
      <Helmet title={SEO.head.title} meta={SEO.head.meta}>
        <meta property="og:title" content={SEO.head.title} />
        <meta property="og:description" content={SEO.head.meta[0].content} />
      </Helmet>
      <HeroSection startOnboarding={startOnboarding} />
      <BannerImageSection />
      <ExploreGoustoSection startOnboarding={startOnboarding} />
      <MenuCarousel startOnboarding={startOnboarding} />
      <HowDoesGoustoMenuWork startOnboarding={startOnboarding} />
      <HowMuchDoesGoustoCost startOnboarding={startOnboarding} />
      <WhyChooseGoustoSection startOnboarding={startOnboarding} />
      <TestimonialSection />
      <FAQSection startOnboarding={startOnboarding} />
      <ExploreMenuSection startOnboarding={startOnboarding} />
      <MealPlanningBannerSection />
    </>
  )
}
